module.exports = __webpack_public_path__ + "img/comment.383cd664.svg";